import { Link } from 'react-router-dom';
import { ArrowRight } from '../ui/Icons';

const STEPS = [
  { n: '01', label: 'Measure your space' },
  { n: '02', label: 'Pick your finish' },
  { n: '03', label: 'Get your estimate' },
];

const FinalCTA = () => (
  <section className="relative overflow-hidden bg-gradient-to-br from-brand-blue via-[#1e2f75] to-brand-red">
    {/* decorative blooms */}
    <div className="pointer-events-none absolute -top-24 -left-16 w-96 h-96 rounded-full bg-white/10 blur-3xl vp-float" />
    <div className="pointer-events-none absolute -bottom-28 right-0 w-[26rem] h-[26rem] rounded-full bg-brand-gold/20 blur-3xl vp-float" style={{ animationDelay: '2s' }} />

    <div className="relative container py-16 md:py-24">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div className="text-white">
          <span className="vp-eyebrow vp-eyebrow-light">Plan your project</span>
          <h2 className="vp-heading !text-white mt-4 text-3xl sm:text-4xl lg:text-[2.9rem]">Know what your painting project will cost</h2>
          <p className="mt-5 text-white/80 leading-relaxed max-w-lg">
            Enter your area and choose a product — our calculator returns the paint quantity and an indicative cost in seconds. No sign-up needed.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <Link to="/CalculateNow" className="vp-btn vp-btn-gold text-base">
              Calculate Now
              <ArrowRight />
            </Link>
            <Link to="/contact" className="vp-btn vp-btn-ghost text-base">
              Talk to an expert
            </Link>
          </div>
        </div>

        {/* Steps card */}
        <div className="lg:justify-self-end w-full max-w-md">
          <div className="vp-glass rounded-2xl p-7 sm:p-8">
            <h3 className="text-white font-semibold text-lg">Three steps, two minutes</h3>
            <ol className="mt-6 space-y-5">
              {STEPS.map((s) => (
                <li key={s.n} className="flex items-center gap-4">
                  <span className="flex-shrink-0 w-11 h-11 rounded-xl bg-brand-gold text-brand-ink font-bold flex items-center justify-center tabular-nums">{s.n}</span>
                  <span className="text-white/90 font-medium">{s.label}</span>
                </li>
              ))}
            </ol>
            <p className="mt-7 pt-5 border-t border-white/20 text-sm text-white/65">Prefer to speak to someone? Our team can walk your site and quote the full job.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default FinalCTA;
